import React from 'react';
import { useHistory } from 'react-router-dom';

import { handleRedirection } from 'utils/utils';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export default function LeadItem({ data }) {
  const history = useHistory();

  return (
    <div className="border shadow-small p-3 my-2 msg-dtls">
      <div className="my-2 text-break">
        <span className="text-medium">Practice area:</span> {data?.case_description?._case_practice_area_ || 'N/A'}
      </div>
      <div
        className="my-2 text-break"
        onClick={() => {
          const route = data?.case_id ? `/leads/${data?.case_id}` : '/leads';
          handleRedirection(history, route);
        }}
      >
        <span className="text-medium">Lead:</span>
        <Link to={data?.case_id ? `/leads/${data?.case_id}` : '/leads'} className="redirection-link-no-text-transform">
          <span className="text-primary-dark redirection-link-no-text-transform ms-1">{data?.case_description?.case_name ?? 'N/A'}</span>
        </Link>
      </div>
      <div className="my-2 text-break">
        <span className="fw-bold">Lead Status:</span> {data?._lead_stage_name_ === 'Closed' ? 'INACTIVE' : data?.status ?? 'N/A'}
      </div>
    </div>
  );
}
